/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

export interface WallpaperPreset {
  id: string;
  label: string;
  css: string; // CSS `background` shorthand value
}

// Curated gradients instead of bundled photos -- always render crisp at any
// resolution, need no asset hosting, and keep the whole feature client-only.
// Users who want an actual photo already have the URL/upload options.
export const WALLPAPER_PRESETS: WallpaperPreset[] = [
  {
    id: "aurora",
    label: "Aurora",
    css: "linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)",
  },
  {
    id: "sunset",
    label: "Sunset",
    css: "linear-gradient(135deg, #ff7e5f 0%, #feb47b 100%)",
  },
  {
    id: "ocean",
    label: "Ocean",
    css: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
  },
  {
    id: "midnight",
    label: "Midnight",
    css: "linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)",
  },
  {
    id: "forest",
    label: "Forest",
    css: "linear-gradient(135deg, #134e5e 0%, #71b280 100%)",
  },
  {
    id: "slate",
    label: "Slate",
    css: "linear-gradient(135deg, #232526 0%, #414345 100%)",
  },
  {
    id: "candy",
    label: "Candy",
    css: "linear-gradient(135deg, #ee9ca7 0%, #ffdde1 100%)",
  },
  {
    id: "nebula",
    label: "Nebula",
    css: "radial-gradient(circle at 30% 20%, #6a11cb 0%, #2575fc 60%, #0f0c29 100%)",
  },
];
